/**
 * Normalize a host or partial API URL to the v1 REST base used by agent endpoints.
 */
export function normalizeAgentApiBase(apiBase: string | undefined): string | undefined {
  if (!apiBase) {
    return undefined;
  }

  let normalized = apiBase.startsWith('http') ? apiBase : `https://${apiBase}`;
  normalized = normalized.replace(/\/+$/, '');

  if (normalized.endsWith('/api/v1')) {
    return `${normalized}/`;
  }

  if (normalized.endsWith('/api')) {
    return `${normalized}/v1/`;
  }

  return `${normalized}/api/v1/`;
}
